/* eslint-disable @typescript-eslint/no-unused-vars */
import { Action } from '@reduxjs/toolkit';
import { Epic, StateObservable, ofType } from 'redux-observable';
import { Observable, catchError, concatMap, from, map, of } from 'rxjs';

import { Dependencies } from '@configurations/dependencies/dependencies';
import { Zone } from '@scenario/models/zone.model';
import { RootState } from '@store/create-store';
import { retrievePriceZonesFailure, retrievePriceZonesSuccess } from '@store/price-card/price-zone/price-zone.slice';

export const retrievePriceZonesEpic: Epic<Action, Action, RootState, Dependencies> = (
  action$: Observable<Action>,
  _state$: StateObservable<RootState>,
  dependencies: Dependencies,
) =>
  action$.pipe(
    ofType('priceZones/retrievePriceZones'),
    concatMap((_action: Action) =>
      from(dependencies.priceZoneGateway.retrieveAll()).pipe(
        map((regions: Zone[]) => retrievePriceZonesSuccess(regions)),
        catchError(() => of(retrievePriceZonesFailure('Fail to retrieve price zones'))),
      ),
    ),
  );
